/**
 * Dynamic loader for interactive product tours.
 *
 * Each tour is a self-contained JSON file under src/guides/tours/<id>.json
 * adhering to src/guides/tour.schema.json.
 */

const normalisePath = (pathname = "") =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

/**
 * Loads all tour JSON files from ./tours using require.context in Webpack,
 * falling back to Node fs in Jest tests.
 */
export const loadAllTours = () => {
  try {
    const ctx = require.context("./tours", false, /\.json$/);
    return ctx.keys().map((key) => ctx(key));
  } catch {
    const fs = require("fs");
    const path = require("path");
    const dir = path.join(__dirname, "tours");
    return fs
      .readdirSync(dir)
      .filter((file) => file.endsWith(".json"))
      .map((file) => JSON.parse(fs.readFileSync(path.join(dir, file), "utf8")));
  }
};

/** All tours keyed by normalised pathname (e.g. "/geo-dashboard"). */
export const TOURS = loadAllTours().reduce((acc, tour) => {
  acc[normalisePath(tour.route)] = tour;
  return acc;
}, {});

/** Returns the tour configured for a route, or null. */
export const getTourForPath = (pathname) =>
  TOURS[normalisePath(pathname)] || null;

/** CSS selector for an anchor id. Kept here so the attribute name lives in one place. */
export const TOUR_ANCHOR_ATTR = "data-tour";
export const anchorSelector = (anchor) => `[${TOUR_ANCHOR_ATTR}="${anchor}"]`;
export { normalisePath };
